export enum EFont {
  Fira_Sans = 'Fira Sans',
}
